import React, { useState, useEffect } from 'react';
import { useDispatch } from "react-redux";
import Form, { ButtonItem, ButtonOptions, GroupItem, Item, Label, RequiredRule, CheckBox } from "devextreme-react/form";
import Request from "../../../components/api/Request";
import * as AppActions from '../../../actions/AppActions';
import { ToastType } from "../../../constants/Constants";
import { showToast, parseDate, hasRole } from "../../../utils/Utils";

const KullaniciDetay = (props) => {

    const dispatch = useDispatch();

    const [formYetki, setFormYetki] = useState(
        {
            listele: hasRole("tanimlar|kullanici|listele"),    
            goruntule: hasRole("tanimlar|kullanici|goruntule"),  
            ekle: hasRole("tanimlar|kullanici|ekle"),  
            degistir: hasRole("tanimlar|kullanici|degistir"),  
            sil: hasRole("tanimlar|kullanici|sil"),  
            domainList: hasRole("tanimlar|kullanici|domainList"),    
            roleList: hasRole("tanimlar|kullanici|roleList"),    
            userDomainSave: hasRole("tanimlar|kullanici|userDomainSave"),    
            userRoleSave: hasRole("tanimlar|kullanici|userRoleSave")
        });


    const [kullanici, setKullanici] = useState();
    useEffect(() => {
        getKullanici();
    }, [])

    const getKullanici = () => {

        let id = -1;
        if (props.data && props.data.id) {
            id = props.data.id;
        }
        const request = new Request("/kullanici/getKayit/" + id, "GET");
        return request.run()
            .then(response => {
                setKullanici(response.data.data);
            });
    }
    function kaydet(e) {

        let eksikBilgi = false;
        e.validationGroup.validators.map((a) => {
            if (a.validate().status !== "valid") {
                eksikBilgi = true;
            }
        }
        );
        if (eksikBilgi) {
            showToast('Zorunlu alanları kontrol ediniz', ToastType.ERROR, 500);
            return;
        }

        let data = kullanici; 
       
        let method = "POST"
        let url = "/kullanici/createKayit";
        if (data.id && data.id > 0) {
            method = "PUT";
            url = "/kullanici/updateKayit";
        }

        const request = new Request(url, method, data);
        dispatch(AppActions.setLoading(true, "Kayıt işlemi yapılıyor.."));
        return request.run()
            .then(response => {
                dispatch(AppActions.setLoading(false, ""));
                if (response.data && response.data.data) {
                    props.hide();
                }
            });


    }


    return (
        <div >
            <Form formData={kullanici} colCount={1} id="form" labelLocation={"left"} className="option" >

                <Item disabled={false} dataField={'username'} editorType={'dxTextBox'}>
                    <RequiredRule message="UserName bilgisi gerekli" />
                    <Label text='Username' />
                </Item>
                <Item disabled={false} dataField={'password'} editorType={'dxTextBox'} editorOptions={{ mode: "password" }}>
                    <Label text='Şifre' />
                </Item>

                <Item disabled={false} dataField={'state'} editorType={'dxCheckBox'}>
                    <RequiredRule message="UserName bilgisi gerekli" />
                    <Label text='Durum' />
                </Item>



                <ButtonItem>
                    <ButtonOptions
                        onClick={(e) => { kaydet(e); }}
                        width={'100%'}
                        type={'success'}
                        visible={formYetki.degistir || formYetki.ekle}
                        useSubmitBehavior={true}>
                        <span className="dx-button-text">
                            {'Kaydet'
                            }
                        </span>
                    </ButtonOptions>
                </ButtonItem>

            </Form>


        </div>
    )
}

export default KullaniciDetay;
